export type FormaEmissao = {
  value: number;
  label: string;
};

export const formaEmissao: FormaEmissao[] = [
  { value: 0, label: 'Normal' },
  { value: 1, label: 'Contingência SVC-AN' },
];
